import { Box } from "@mui/material";

const getSuccessRateColor = (rate) => {
  if (rate >= 95) return { bg: "#ecfdf5", color: "#065f46" };
  if (rate >= 85) return { bg: "#fffbeb", color: "#92400e" };
  return { bg: "#fef2f2", color: "#991b1b" };
};

export const TransactionPerformanceColumns = [
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Channel</div>,
    cell: ({ row }) => (
      <div
        style={{ fontSize: "0.85rem", whiteSpace: "nowrap", fontWeight: 500 }}
      >
        {row.original.name ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "transaction_count",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Total Count</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.transaction_count_formatted ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "transaction_volume",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Total Volume</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.transaction_volume_formatted ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "success_count",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Success Count</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.success_count_formatted ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "failed_count",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Failed Count</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", color: "#991b1b" }}>
        {row.original.failed_count_formatted ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "success_rate",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Success Rate</div>,
    cell: ({ row }) => {
      const rate = row.original.success_rate;
      if (rate == null) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
      const { bg, color } = getSuccessRateColor(rate);
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: bg,
            color: color,
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          {rate.toFixed(1)}%
        </Box>
      );
    },
  },
  {
    accessorKey: "avg_transaction_value",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Avg. Value</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.avg_transaction_value_formatted ?? "N/A"}
      </div>
    ),
  },
];
